import type { FormResponseValue } from "@tellescope/types-models";

/**
 * Whether a response belongs in a submission payload.
 *
 * A `Redirect` field never produces an answer — its component only navigates — so its row carries the
 * empty seed. Legacy submitted that row and this filter is a deviation from it (see deviation #58),
 * but the API rejects the payload: `formResponseAnswerValidator` gives `Redirect` a bare
 * `stringValidator`, which throws "Expecting non-empty string" on `''`, while the sibling
 * `Appointment Booking` branch uses `stringValidatorOptional`. Submitting the row therefore fails the
 * whole submission for any form containing a Redirect field.
 *
 * Remove this filter once `Redirect`'s validator is relaxed to `stringValidatorOptional` server-side;
 * legacy parity is the intended end state.
 */
export const isSubmittableResponse = (response: FormResponseValue): boolean => response.answer.type !== "Redirect";
